import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shipd.svg'
import _imports_1 from '@/assets/appstoreBadge.svg'
import _imports_2 from '@/assets/googleplayBadge.svg'
import _imports_3 from '@/assets/xmark.svg'


const _withScopeId = n => (_pushScopeId("data-v-57e82810"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = { class: "download-wrapper" }
const _hoisted_4 = { class: "download" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Get the desktop client", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Available for "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Windows 10, 11 and MacOS ")
], -1))
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"download\" data-v-57e82810><h1 data-v-57e82810>And get it for mobile</h1><div class=\"plattforms\" data-v-57e82810><a target=\"_blank\" href=\"https://apps.apple.com/se/app/shipd-mobile/id6443850361?l=en\" data-v-57e82810><img class=\"plattform\" src=\"" + _imports_1 + "\" alt=\"apple\" data-v-57e82810></a><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=co.getshipd.mobile\" data-v-57e82810><img class=\"plattform\" src=\"" + _imports_2 + "\" alt=\"android\" data-v-57e82810></a></div></div>", 1)
const _hoisted_8 = { class: "btns" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cross-img",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_ManageAccount = _resolveComponent("ManageAccount")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = () => $setup.download($setup.OSName))
          }, _toDisplayString($setup.OSName == "MacOS" ? "Download for MacOS" : "Download for Windows"), 1),
          _createVNode(_component_ToggleButton, {
            onChange: $setup.toggleEvent,
            labelEnableText: "Windows",
            labelDisableText: "MacOS",
            defaultState: $setup.OSName == 'MacOS'
          }, null, 8, ["onChange", "defaultState"])
        ]),
        _hoisted_7
      ]),
      _createVNode(_component_router_link, { to: "/releasenotes" }, {
        default: _withCtx(() => [
          _createTextVNode("View release notes")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "width secondary mainBtn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showManage = true))
        }, " Manage Account ")
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.showManage)
        ? (_openBlock(), _createBlock(_component_ManageAccount, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "cross",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showManage = false))
              }, _hoisted_10)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}